import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { ServicesCategory } from '../ServicesGrid';

export function filterServices(
  services: ServicesCategory[],
  tenantAlias: string,
  flags: LDFlagSet,
): ServicesCategory[] {
  const filteredCategories = services.map(({ category, items, categoryId }) => {
    return {
      category,
      items: items.filter(({ LDEnableFeatureFlag, tenants }) => {
        // determine visibility, based on FF from LD
        const ffEnabled =
          LDEnableFeatureFlag && flags[LDEnableFeatureFlag] !== undefined
            ? flags[LDEnableFeatureFlag]
            : true;

        const isInScope = () => tenants?.only?.includes(tenantAlias);
        const isIgnored = () => tenants?.ignore?.includes(tenantAlias);

        const tenantEnabled = tenants
          ? // if tenant is not ignored OR if tenant is
            tenants.only
            ? isInScope()
            : tenants.ignore
            ? !isIgnored()
            : true
          : true;

        return ffEnabled && tenantEnabled;
      }),
      categoryId,
    };
  });

  return filteredCategories.filter(({ items }) => items.length > 0);
}
